import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Pipe({
    name: 'unitTypesByBlockId',
    pure: false
})
export class PipeUnitTypesByBlockId implements PipeTransform {
    transform(unitTypesDS, blockId, key: any = false): any {
        var r = [];

        if (!unitTypesDS.length)
            return r;

        var ids = unitTypesDS.filter(item => item['blockId'] == blockId);

        for (var k in ids)
        if (ids.hasOwnProperty(k))
            r.push(key === false ? ids[k] : ids[k][key]);

        return r;
      
    }
}